var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5146 4.23277C11.6841 4.37753 11.8462 4.53132 12 4.69342C12.1538 4.53132 12.3159 4.37754 12.4854 4.23278C13.5701 3.30656 14.9617 2.75 16.4792 2.75C19.9425 2.75 22.75 5.6489 22.75 9.22504C22.75 15.7757 16.8438 18.7784 13.1389 20.6621C12.7286 20.8707 12.3453 21.0656 12 21.25C11.6547 21.0656 11.2714 20.8707 10.8611 20.6621C7.15616 18.7784 1.25 15.7757 1.25 9.22504C1.25 5.6489 4.05754 2.75 7.52083 2.75C9.03833 2.75 10.4299 3.30655 11.5146 4.23277ZM12 19.558C12.1726 19.4694 12.3489 19.3797 12.5281 19.2884C14.1668 18.4539 16.0547 17.4924 17.7175 16.1166C19.7524 14.4329 21.25 12.2761 21.25 9.22504C21.25 6.43166 19.0691 4.25 16.4792 4.25C15.1602 4.25 13.9602 4.80702 13.088 5.72599L12 6.87246L10.912 5.72599C10.0398 4.80702 8.83975 4.25 7.52083 4.25C4.93091 4.25 2.75 6.43166 2.75 9.22504C2.75 12.2761 4.24759 14.4329 6.2825 16.1166C7.94527 17.4924 9.83321 18.4539 11.4719 19.2884C11.6511 19.3797 11.8274 19.4694 12 19.558Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/HeartOutline.6f2a03d711840969880857ca39033df9.svg";
export { ForwardRef as ReactComponent };